function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Icon, Alert } from 'mkui-fd';
import SourceList from './components/SourceList';
import TargetList from './components/TargetList';
import Tabs from './components/Tabs';

var AbstractTransfer = /*#__PURE__*/function (_Component) {
  _inherits(AbstractTransfer, _Component);

  function AbstractTransfer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AbstractTransfer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AbstractTransfer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: []
    });

    _defineProperty(_assertThisInitialized(_this), "clearHandle", function () {
      _this.onChangeHandle([]);
    });

    _defineProperty(_assertThisInitialized(_this), "selectSourceList", function (data) {
      return _this.onChangeHandle(data);
    });

    _defineProperty(_assertThisInitialized(_this), "removeSourceList", function (data) {
      var value = _this.state.value;

      _this.onChangeHandle(value.filter(function (item) {
        return item.key !== data;
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeHandle", function (value) {
      var onChange = _this.props.onChange;

      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }

      onChange(value);
    });

    return _this;
  }

  _createClass(AbstractTransfer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          selectType = _this$props.selectType,
          tabData = _this$props.tabData,
          onTabChange = _this$props.onTabChange,
          showSearch = _this$props.showSearch,
          searchPlaceholder = _this$props.searchPlaceholder,
          dataSource = _this$props.dataSource,
          sourceListProps = _this$props.sourceListProps,
          targetListProps = _this$props.targetListProps,
          customSourceHeader = _this$props.customSourceHeader,
          customTargetHeader = _this$props.customTargetHeader,
          onSearch = _this$props.onSearch;
      var value = this.state.value;

      var _targetListProps = _objectSpread({}, targetListProps, {
        option: function option(_ref) {
          var key = _ref.key;
          return React.createElement(Icon, {
            type: "trash",
            onClick: function onClick() {
              return _this2.removeSourceList(key);
            }
          });
        }
      });

      return React.createElement("div", {
        className: prefixCls
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-box left")
      }, React.createElement(Tabs, {
        data: tabData,
        onChange: onTabChange,
        size: "small"
      }), showSearch && React.createElement("div", {
        className: "".concat(prefixCls, "-input-search")
      }, React.createElement(Input.Search, {
        placeholder: searchPlaceholder,
        onSearch: onSearch
      })), React.createElement("div", {
        className: "".concat(prefixCls, "-custom-header")
      }, customSourceHeader), React.createElement(SourceList, {
        selectType: selectType,
        data: dataSource,
        renderProps: sourceListProps,
        onChange: this.selectSourceList,
        checkedList: value
      })), React.createElement(Icon, {
        className: "".concat(prefixCls, "-box middle"),
        type: "right"
      }), React.createElement("div", {
        className: "".concat(prefixCls, "-box right")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-box-title")
      }, customTargetHeader ? customTargetHeader : React.createElement("h1", {
        className: "".concat(prefixCls, "-box-title-header")
      }, "\u5DF2\u9009", React.createElement("span", {
        className: "".concat(prefixCls, "-box-title-number")
      }, value.length), "\u9879"), React.createElement("a", {
        className: "".concat(prefixCls, "-box-title-empty"),
        disabled: value.length === 0,
        onClick: this.clearHandle
      }, "\u6E05\u7A7A")), selectType === 'radio' && React.createElement(Alert, {
        className: "".concat(prefixCls, "-alert"),
        showIcon: true,
        type: "info",
        message: "\u6700\u591A\u53EA\u80FD\u9009\u62E9 1 \u9879"
      }), React.createElement(TargetList, {
        data: value,
        renderProps: _targetListProps
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value || []
        };
      }

      return null;
    }
  }]);

  return AbstractTransfer;
}(Component);

_defineProperty(AbstractTransfer, "propTypes", {
  prefixCls: PropTypes.string,
  selectType: PropTypes.string,
  showSearch: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  onSearch: PropTypes.func,
  tabData: PropTypes.any.isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.any.isRequired,
    title: PropTypes.string
  })),
  customSourceHeader: PropTypes.node,
  customTargetHeader: PropTypes.node,
  onTabChange: PropTypes.func,
  onChange: PropTypes.func
});

_defineProperty(AbstractTransfer, "defaultProps", {
  prefixCls: 'mkui-abstract-transfer',
  showSearch: true,
  searchPlaceholder: '输入关键字、按回车搜索',
  selectType: 'multiple',
  tabData: [],
  dataSource: [],
  onTabChange: function onTabChange() {},
  onChange: function onChange() {},
  onSearch: function onSearch() {}
});

export { AbstractTransfer as default };
//# sourceMappingURL=AbstractTransfer.js.map
